import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { createThemeSlice, ThemeSlice } from './slices/themeSlice'
import { createUISlice, UISlice } from './slices/uiSlice'
import { createAuthSlice, AuthSlice } from './slices/authSlice'
import { createContactSlice, ContactSlice } from './slices/contactSlice'
import { createPortfolioSlice, PortfolioSlice } from './slices/portfolioSlice'
import { createServicesSlice, ServicesSlice } from './slices/servicesSlice'

// Combined store type
export type AppStore = ThemeSlice & UISlice & AuthSlice & ContactSlice & PortfolioSlice & ServicesSlice

// Create the main store (simplified without persistence for now)
export const useAppStore = create<AppStore>()(
  devtools(
    immer((...a) => ({
      ...createThemeSlice(...a),
      ...createUISlice(...a),
      ...createAuthSlice(...a),
      ...createContactSlice(...a),
      ...createPortfolioSlice(...a),
      ...createServicesSlice(...a),
    })),
    {
      name: 'oasis-devps-store',
    }
  )
)

// Export individual slices for convenience
export const useTheme = () => useAppStore((state) => state.theme)
export const useUI = () => useAppStore((state) => state.ui)
export const useAuth = () => useAppStore((state) => state.auth)
export const useContact = () => useAppStore((state) => state.contact)
export const usePortfolio = () => useAppStore((state) => state.portfolio)
export const useServices = () => useAppStore((state) => state.services)

// Selectors for common state combinations
export const useIsLoading = () => useAppStore((state) => state.ui.loading)
export const useIsAuthenticated = () => useAppStore((state) => state.auth.isAuthenticated)
export const useCurrentUser = () => useAppStore((state) => state.auth.user)
export const useCurrentTheme = () => useAppStore((state) => state.theme.mode)
export const useSidebarOpen = () => useAppStore((state) => state.ui.sidebarOpen) 